var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-axis-line-chart"},[_c('div',{ref:"chart",staticClass:"chart_box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }